import { render } from "./ContractAdditionalCreateComponent.vue?vue&type=template&id=5bfcad8d&scoped=true"
import script from "./ContractAdditionalCreateComponent.vue?vue&type=script&lang=js"
export * from "./ContractAdditionalCreateComponent.vue?vue&type=script&lang=js"

import "./ContractAdditionalCreateComponent.vue?vue&type=style&index=0&id=5bfcad8d&scoped=true&lang=css"

import exportComponent from "/Users/dmitriy-pc/Projects/docs.d-services.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bfcad8d"]])

export default __exports__